export const profile = {
  block: {
    user_info: {
      title: 'Data anda'
    },

    company_info: {
      title: 'Info Perusahaan'
    },

    change_password: {
      title: 'Rubah Password',
    }
  },

  form: {
    field: {
      email: {
        title: 'Alamat E-mail',
        placeholder: ''
      },
      timezone: {
        title: 'Timezone'
      },
      phone: {
        title: 'Telephone'
      },
      name: {
        title: 'Nama'
      },
      company: {
        title: 'Perusahaan'
      },
      legal_name: {
        title: 'Nama lengkap'
      },
      contract_number: {
        title: 'Nomor kontrak '
      },
      contract_date: {
        title: 'Tangal kontrak'
      },
      inn: {
        title: 'NPWN'
      },
      bank_details: {
        title: 'Nama Bank'
      },
      password: {
        current: 'Password lama',
        new: 'Password baru',
        new_confirm: 'Konfirmasi sandi'
      }
    }
  }
};
